import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Helmet } from 'react-helmet-async';
import { HospitalityContent } from './components/HospitalityContent';
import { Permission } from '@/models/user';
import { PageWithLayout } from '@/models/page';
import { useAuthentication } from '@/hooks/useAuthentication';
import { useGetLiftOperatorQuery } from '@/api/v2/liftOperator';
import UnAuthorized from '@/pages/UnAuthorized';

const EditPage: PageWithLayout = () => {
    const { liftOperatorData } = useAuthentication();
    const { data: liftoperator } = useGetLiftOperatorQuery({
        liftOperatorId: liftOperatorData?.liftOperatorId,
    });

    if (!liftoperator) {
        return null;
    }

    if (liftoperator.disableHospitality) {
        return <UnAuthorized />;
    }

    return (
        <>
            <Helmet>Hospitality bearbeiten | Starjack Admin</Helmet>

            <HospitalityContent newOrEditMode={true} />
        </>
    );
};

EditPage.isProtected = true;
EditPage.permissions = [Permission.HOSPITALITY_NAV];
EditPage.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;

export default EditPage;
